import { mapRulesToValidators } from '../../utilities';
import { CheckboxField } from './CheckboxField';
import { DatePickerField } from './DatePickerField';
import { DropdownField } from './DropdownField';
import { EntityPickerField } from './EntityPickerField';
import { FilePickerField } from './FilePickerField';
import { MailButtonField } from './MailButtonField';
import { TextboxField } from './TextboxField';

export function createFieldBase(options: FieldBaseArguments): FieldBase {
  const self: FieldBase = {
    key: options.key || '',
    label: options.label || options.key,
    placeholder: options.placeholder || '',
    order: options.order === undefined ? 1 : options.order,
    customOrder: options.customOrder,
    dataType: options.dataType,
    rules: mapRulesToValidators(options.rules),
    size: options.size,
    images: options.images,
    isLocked: options.isLocked,
    textAlign: options.textAlign || 'left',
    groupName: options.groupName,
    isManuallyHidden: false
  };

  self.isHidden = self.order === 0 ? true : options.isHidden;

  if (self.dataType === 'string') {
    self.dtoTransform = (value) => String(value);
  } else if (self.dataType === 'number') {
    self.dtoTransform = (value) => Number(value);
  } else if (self.dataType === 'date'){
    self.dtoTransform = (value) => new Date(value);
  } 
  else {
    self.dtoTransform = (value) => Number(value);
  }

  return self;
}

// TYPES AHEAD
export interface FieldBaseArguments {
  key: string;
  label?: string;
  placeholder?: string;
  rules?: Rules;
  order?: number;
  customOrder?: number;
  dataType?: DataType;
  size?: number;
  images?: boolean; // plan to make this an array of image references
  isLocked?: boolean;
  textAlign?: TextAlign;
  groupName?: string;
  isHidden?: boolean;
  isManuallyHidden?: boolean;
}

export interface FieldBase extends FieldBaseArguments {
  dtoTransform?: Function;
}

export interface CommonField
  extends Partial<TextboxField>,
  Partial<CheckboxField>,
  Partial<DropdownField>,
  Partial<DatePickerField>,
  Partial<EntityPickerField>,
  Partial<MailButtonField>,
  Partial<FilePickerField> { }

export interface PersistedFieldOption {
  key: string;
  isManuallyHidden?: boolean;
  customOrder?: number;
}

export interface Rules {
  required?: Rule1;
  requiredTrue?: Rule1;
  pattern?: Rule2<string>;
  min?: Rule2<number>;
  max?: Rule2<number>;
  minlength?: Rule2<number>;
  maxlength?: Rule2<number>;
}

interface Rule1 {
  message?: string;
}

interface Rule2<T> extends Rule1 {
  value: T;
}

type DataType = 'string' | 'number' | 'boolean' | 'date';

type TextAlign = 'left' | 'center' | 'right';



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/FieldBase.ts